import { KAHVE_MEDIHA } from './kahve_mediha';
import { KAHVE_LEYLA } from './kahve_leyla';
import { KAHVE_AHMET } from './kahve_ahmet';
import { KAHVE_AREN } from './kahve_aren';
import { KAHVE_SINEM } from './kahve_sinem';
import { KAHVE_MECNUN } from './kahve_mecnun';
import { EL_MEDIHA } from './el_mediha';
import { EL_AHMET } from './el_ahmet';
import { EL_MECNUN } from './el_mecnun';
import { YUZ_LEYLA } from './yuz_leyla';
import { YUZ_MECNUN } from './yuz_mecnun';
import { ILISKI_MEDIHA } from './iliski_mediha';
import { ILISKI_AREN } from './iliski_aren';
import { ILISKI_SINEM } from './iliski_sinem';
import { ILISKI_MECNUN } from './iliski_mecnun';
import { TAROT_LUNARA } from './tarot_lunara';
import { YILDIZ_DERVIS } from './yildiz_dervis';

export const TUM_YORUMLAR = {
  kahve: {
    mediha: KAHVE_MEDIHA,
    leyla: KAHVE_LEYLA,
    ahmet: KAHVE_AHMET,
    aren: KAHVE_AREN,
    sinem: KAHVE_SINEM,
    mecnun: KAHVE_MECNUN,
  },
  el: {
    mediha: EL_MEDIHA,
    ahmet: EL_AHMET,
    mecnun: EL_MECNUN,
  },
  yuz: {
    leyla: YUZ_LEYLA,
    mecnun: YUZ_MECNUN,
  },
  iliski: {
    mediha: ILISKI_MEDIHA,
    aren: ILISKI_AREN,
    sinem: ILISKI_SINEM,
    mecnun: ILISKI_MECNUN,
  },
  tarot: {
    lunara: TAROT_LUNARA,
  },
  yildizname: {
    dervis: YILDIZ_DERVIS,
  },
};

// Kullanıcının daha önce gördüğü yorumları hariç tutarak random yorum seç
export function yorumSec(falTuru, falciId, gorulenYorumIds = []) {
  const yorumlar = TUM_YORUMLAR[falTuru]?.[falciId];
  if (!yorumlar || yorumlar.length === 0) return null;

  // Görülmemiş yorumları filtrele
  let gorulemeyenler = yorumlar.filter(y => !gorulenYorumIds.includes(y.id));

  // Hepsi görüldüyse sıfırla
  if (gorulemeyenler.length === 0) {
    gorulemeyenler = yorumlar;
  }

  // Random seç
  const index = Math.floor(Math.random() * gorulemeyenler.length);
  return gorulemeyenler[index];
}

// Yorum metnindeki değişkenleri doldur
export function yorumDoldur(yorum, { ad = '', burc = '', soru = '' }) {
  if (!yorum) return '';
  return yorum.metin
    .replace(/{{ad}}/g, ad || 'dostum')
    .replace(/{{burc}}/g, burc || '')
    .replace(/{{soru}}/g, soru || 'sorduğun konu');
}